// @ts-nocheck
import axios from "@/helpers/interceptors";
import { B2bPortalRight } from "@/enums/B2bPortalRight";
import { vuexHasPortalRight } from "@/helpers/vuexPortalPermissions";

const state = {
  payments: [],
  beneficiaries: [],
  paymentStatus: null,
  paymentById: null,
  isShowPaymentDetailsModal: false,
  paymentCountries: null,
  paymentTabs: null,
  bankDetails: null,
  masterAccountList: null,
  paymentsPurposeCodes: null
};
const mutations = {
  SET_PAYMENTS(state, payments) {
    if (payments) {
      state.payments = payments.map((item) => item);
    }
  },
  SET_PAYMENT_COUNTRIES(state, payload) {
    state.paymentCountries = payload;
  },
  SET_PAYMENT_TABS(state, payload) {
    state.paymentTabs = payload;
  },
  TOGGLE_PAYMENT_DETAILS_MODAL(state, payload) {
    console.log('TOGGLE_PAYMENT_DETAILS_MODAL mutation called with:', payload);
    state.isShowPaymentDetailsModal = payload;
    console.log('Modal state after mutation:', state.isShowPaymentDetailsModal);
  },
  SET_BENEFICIARIES(state, payload) {
    state.beneficiaries = payload;
  },
  UPDATE_PAYMENT_STATUS(state, { id, orderStatus }) {
    state.payments.forEach((item) => {
      if (item.id === id) {
        item.orderStatus = orderStatus;
      }
    });
  },
  SET_PAYMENT_STATUS(state, payload) {
    state.paymentStatus = payload;
  },
  SET_PAYMENT_BY_ID(state, payload) {
    state.paymentById = payload;
  },
  SET_BANK_DETAILS(state, payload) {
    state.bankDetails = payload
  },
  SET_MASTER_ACCOUNTS_LIST(state, payload) {
    state.masterAccountList = payload
  },
  SET_PAYMENTS_PURPOSE_CODES(state, payload) {
    state.paymentsPurposeCodes = payload
  },
  SET_CLIENT_INFO(state, payload) {
    state.clientInfo = payload
  }
};

const actions = {

  /**
   * @name fetchPayments
   * @description get list of payments
   */

  // eslint-disable-next-line consistent-return
  async fetchPayments({ commit, rootState }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentView)) {
      commit("SET_PAYMENTS", []);
      return;
    }
    try {
      const { status, data } = await axios.get("/api/payments/0/100");
      if (status === 200) {
        commit("SET_PAYMENTS", data.transactions);
        return data;
      }
    } catch (e) {
      console.log(e);
    }
  },
  async fetchPaymentOrderDocuments({ rootState }, orderId) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentUploadDocument)) return;
    try {
      const { status, data } = await axios.get(`/api/payments/order-documents/${orderId}`);
      if (status === 200) {
        return data.items;
      }
    } catch (e) {
      console.log(e);
    }
  },

  // Initialize new payment - get available tabs and countries
  async initPayment({ commit, rootState }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { data, status } = await axios.get("/api/payments/init-new-payment");
      if (status === 200) {
        const countries = data.countries?.sort((a, b) => 
          a.countryName.trim().toLowerCase().localeCompare(b.countryName.trim().toLowerCase())
        );
        commit('SET_PAYMENT_COUNTRIES', countries);
        commit('SET_PAYMENT_TABS', data.tabs);
        return data;
      }
    } catch (e) {
      console.log("Error init payment: ", e);
    }
  },

  // получаем список стран с доступными валютами
  async getPaymentCountry({ commit, rootState }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { data, status } = await axios.get("/api/payments/countries");
      if (status === 200) {
        const countries = data.sort((a, b) => a.countryName.trim().toLowerCase().localeCompare(b.countryName.trim().toLowerCase()));
        commit('SET_PAYMENT_COUNTRIES', countries);
        return countries;
      }
    } catch (e) {
      console.log("Error get country for payments: ", e);
    }
  },

  // получаем поля для шаблона по выбраной стране с валютой
  async getPaymentTemplateByCountry({ rootState }, data) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    return await axios.get(`/api/payments/template`, { params: data });
  },

  // получаем бенифициара
  async getBeneficiaries({ rootState }, body) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { status, data } = await axios.post("/api/payments/beneficiaries", body);
      if (status === 200) {
        return { status, data }
      }
      return { status };
    } catch (e) {
      console.log("Error get beneficiary id: ", e);
    }
  },

  async getBeneficiaryById({ rootState }, id) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { status, data } = await axios.get(`/api/payments/beneficiaries/${id}`);
      if (status === 200) {
        return { status, data }
      }
      return { status };
    } catch (e) {
      console.log("Error get beneficiary id: ", e);
    }
  },

  // eslint-disable-next-line consistent-return
  async validatePayment({ rootState }, params) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { status, data } = await axios.post("/api/payments/validate", params);
      if (status && status === 200) {
        return { status, data };
      }
    } catch (e) {
      console.log("Error validate payment", e);
    }
  },

  async getPaymentFees({ rootState }, params) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { status, data } = await axios.get("/api/payments/fee", { params });
      if (status === 200) {
        return { data, status }
        // await dispatch("validatePayment");
      }
    } catch (e) {
      console.log("Error get payment fees", e);
    }
  },
  async attachOrderFile({ rootState }, data) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    return await axios.post("/api/payments/attachOrderFile", data);
  },

  // eslint-disable-next-line consistent-return
  async paymentConfirmation({
    commit, dispatch, rootState
  }, { code, otpId, files }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { status, data } = await axios.post("/api/payments/create", {
        otpId,
        code
      });

      if (status === 200) {
        await dispatch("getPaymentById", data.referenceNumber);
        // await dispatch("paymentInit");
        commit("SET_PAYMENT_STATUS", data);
        if (files.length) {
          try {
            await dispatch("attachOrderFile", { orderId: data.id, files });
          } catch (e) {
            console.log(e, "attachOrderFile");
          }
        }
        return { data, status };
      }
    } catch (e) {
      console.log("Error payment confirmation", e);
    }
  },

  async getPaymentById({ commit, dispatch }, id) {
    try {
      const { transactions } = await dispatch("fetchPayments");
      const payment = transactions.find(({ referenceNumber }) => referenceNumber === id);
      console.log(payment);
      if (payment) {
        commit("SET_PAYMENT_BY_ID", payment);
      }
    } catch (e) {
      console.log("Error get payment by id", e);
    }
  },

  // eslint-disable-next-line consistent-return
  // async paymentInit({ commit }) {
  //   try {
  //     const { status, data } = await axios.get("/api/payments/init");
  //     if (status === 200) {
  //       commit("SET_REGULAR_PAYMENTS_LIST", data.regularPayments);
  //       commit("SET_BENEFICIARIES", data.beneficiaries);
  //       return data;
  //     }
  //   } catch (e) {
  //     console.log("Error payment init", e);
  //   }
  // },

  async getClientInfoByIbanOrAccountNumber({ commit, rootState }, { ibanOrAccountNumber, bankCode }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const params = bankCode ? `${ibanOrAccountNumber}/${bankCode}` : `${ibanOrAccountNumber}`
      const { data, status } = await axios.get(`/api/payments/client/${params}`);
      if (status == 200) {
        commit("SET_CLIENT_INFO", data)
        return { data, status }
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async validateIban({ rootState }, { countryCode, iban }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    return await axios.get(`/api/payments/validate-iban/${countryCode}/${iban}`);
  },

  async getBicCandidates({ rootState }, iban) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    return await axios.get(`/api/payments/bic-candidates/${iban}`);
  },

  async getBankDetails({ commit, rootState }, params) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { data, status } = await axios.get(`/api/payments/bank-details/${params.payment_type}/${params.code}`);
      if (status == 200) {
          if (params.payment_type == 'sort_code') {
              data.sort_code = params.code;
          } else if (params.payment_type == 'iban') {
              data.iban = params.code;
          } else if (params.payment_type == 'bic_swift') {
              data.bicSwift = params.code
          } else if (params.payment_type == 'cbu') {
              data.bankRoutingCode = params.code
          }
        data.payment_type = params.payment_type
        if (params.accountNumber) {
          data.accountNumber = params.accountNumber
        }
        commit("SET_BANK_DETAILS", data)
        return { data, status }
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async getMasterAccountsList({ commit, rootState }) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.AccountView)) return;
    try {
      const { data, status } = await axios.get('/api/accounts/related-accounts')
      if (status == 200) {
        commit("SET_MASTER_ACCOUNTS_LIST", data?.whiteLabels)
      }
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async getPaymentsPurposeCodes({ commit, rootState }, countryCode) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { data, status } = await axios.get(`/api/payments/purpose-codes/${countryCode}`)
      if (status == 200) {
        commit("SET_PAYMENTS_PURPOSE_CODES", data)
      }
    } catch (e) {
      console.log("getPaymentsPurposeCodes e")
    }
  },
  async getAvailableAmounts({ rootState }, {clientId, currency}) {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd)) return;
    try {
      const { status, data } = await axios.get(`/api/payments/available-amount/${clientId}/${currency}`);
      if (status === 200) {
        return { data, status }
      }
    } catch (e) {
      console.log("Error get available amounts: ", e);
    }
  },

  async sendMerchantInvoice(_, { clientId, email }) {
    return await axios.post(`/api/payments/merchant/${clientId}/invoice/email`, { email });
  },

};

const getters = {

  // drafts: (state) => (state.payments.length
  //   ? state.payments.filter((item) => item.orderStatus === "Created") : []),
  // scheduled: (state) => (state.payments.length
  //   ? state.payments.filter((item) => item.orderStatus === "Scheduled") : []),
  drafts: () => [],
  processing: (state, _g, rootState) => {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentView)) return [];
    return state.payments.length
      ? state.payments.filter((item) => item.orderStatus === "Held" || item.orderStatus === "Pending" || item.orderStatus === "InProcess" || item.orderStatus === "Created")
      : [];
  },
  completed: (state, _g, rootState) => {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentView)) return [];
    return state.payments.length
      ? state.payments.filter((item) => item.orderStatus === "Accepted" || item.orderStatus === "Storno")
      : [];
  },
  rejected: (state, _g, rootState) => {
    if (!vuexHasPortalRight(rootState, B2bPortalRight.PaymentView)) return [];
    return state.payments.length
      ? state.payments.filter((item) => item.orderStatus === "Rejected" || item.orderStatus === "Blocked" || item.orderStatus === "Declined")
      : [];
  },
  paymentStatus: (state) => state.paymentStatus,
  paymentById: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.PaymentView) ? state.paymentById : null,
  paymentCountries: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd) ? state.paymentCountries : null,
  paymentTabs: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd) ? state.paymentTabs : null,
  bankDetails: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd) ? state.bankDetails : null,
  masterAccountList: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.AccountView) ? state.masterAccountList : null,
  paymentsPurposeCodes: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd) ? state.paymentsPurposeCodes : null,
  clientInfo: (state, _g, rootState) =>
    vuexHasPortalRight(rootState, B2bPortalRight.PaymentAdd) ? state.clientInfo : null
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions
};
